var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

var colorSaleLabel = '#e95144';
var borderColorSaleLabel = '#e95144';
var bgSaleLabel = '#fff';
var colorSoldOutLabel = '#d2d8db';
var borderColorSoldOutLabel = '#d2d8db';
var bgSoldOutLabel = '#fff';

// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    activeScrollToTop: true,
    loadProductFirst: false,
    extraSortingList: 'extra-sort1-descending|extra-sort2-descending'
  }
};


// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout label" {{style}}>' + bcSfFilterConfig.label_basic.sold_out + '</span>',
    'saleLabelHtml': '<span class="sale label" {{style}}>' + bcSfFilterConfig.label_basic.sale + '</span>',
    'vendorHtml': '<p class="bc-sf-filter-product-item-vendor">{{itemVendorLabel}}</p>',

    // Grid Template
    'productGridItemHtml': '<div boost-item="{{itemId}}" data-status="{{itemStatus}}" class="yc-product-item {{soldOutClass}}{{saleClass}}">' +
      '<div class="yc-product-item-inner">' +
          '<a href="{{itemUrl}}" class="yc-product-item-link">' +
            '<span class="yc-product-left">' +
              '<span class="yc-product-item-image">{{itemImages}}</span>' +
              '<span class="yc-product-item-label">{{itemLabels}}</span>' +
            '</span>' +
            '<span class="yc-product-right">' +
                '<h3 class="yc-product-item-title normal-case">{{itemTitle}}</h3>' +
                '<span class="yotpo bottomLine" data-product-id="{{productId}}"></span>' +
                '{{itemVendor}}' +
                '{{itemCarrierStorage}}'+
                '{{itemVariants}}' +
            '</span>' +
            '<span class="yc-product-bottom">'+
              '<span class="yc-product-item-condition">{{itemCondition}}</span>' +
              '<span class="yc-product-item-price">{{itemPrice}}</span>'+
            '</span>' +
          '</a>' +
      '</div>' +
      '{{itemCta}}' +
      '{{affirmText}}' +
    '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="bc-sf-arrow"><a href="{{itemUrl}}" class="page-item"><i class="fas fa-angle-double-left"></i> Prev</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li class="bc-sf-arrow"><a href="{{itemUrl}}" class="page-item">Next <i class="fas fa-angle-double-right"></i></a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}" class="page-item">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label for="sorting">' + bcSfFilterConfig.label.sorting + '</label><select class="bc-sf-filter-filter-dropdown" id="sorting">{{sortingItems}}</select>',

    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',

    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

function prepareShopifyData(data) {
  var isUpgradedProduct = false;
  var metafields = data.metafields;
  data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/


/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    var self = this;
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Add Custom class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Grid Width class
    itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));

    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Price
    var itemPriceObject = buildPrice(data);

    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceObject.html);

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    if (soldOut) {
      itemHtml = itemHtml.replace(/{{itemStatus}}/g, "0");
    }else{
      itemHtml = itemHtml.replace(/{{itemStatus}}/g, "1");
    }
  
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{productId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{itemCarrierStorage}}/g, buildCarrierStorage(data))
    itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data, "Cosmetic Condition"));
    itemHtml = itemHtml.replace(/{{itemCondition}}/g, buildVariants(data, null, "Cosmetic Condition"));
    if (soldOut) {
        itemHtml = itemHtml.replace(/{{itemCta}}/g, '<div class="notify-me view-cta">SOLD OUT<br /><a class="btn btn-primary btn-sm" href="'+this.buildProductItemUrl(data)+'">Notify Me</a></div>');
    }
    else {
      itemHtml = itemHtml.replace(/{{itemCta}}/g, '<a class="btn btn-primary btn-sm view-cta" onclick="localStorage.setItem('+"'current_collection_url'"+', window.location.href);" href="'+this.buildProductItemUrl(data)+'">View</a>');
    }
    itemHtml = itemHtml.replace(/{{affirmText}}/g, buildAffirmText(data, itemPriceObject.discountedPrice));
    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;
        data[k]['tags'].forEach(function(tag) {
          var split = tag.split(':');
          if(tag.indexOf('Carrier:') >= 0)
            data[k]['carrier'] = split[1];
          else if(tag.indexOf('Storage:') >= 0)
            data[k]['capacity'] = split[1];
          else if(tag.indexOf('Processor:') >= 0)
            data[k]['processor'] = split[1];
          else if(tag.indexOf('Memory:') >= 0)
            data[k]['memory'] = split[1];
          else if(tag.indexOf('Screen:') >= 0)
            data[k]['screen'] = split[1];
          else if(tag.indexOf('Release:') >= 0)
            data[k]['release'] = split[1];
          else if(tag.indexOf('Condition:') >= 0)
            data[k]['condition'] = split[1];
        });
        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

    // Add Description
    data[k]['description'] = data[k]['body_html'];
  }
  return data;
};

/************************** END BUILD PRODUCT LIST **************************/

/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
    var html = '';
    // Build Main Image
    var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src'], '150x150') : bcSfFilterConfig.general.no_image_url;
    html += '<img src="' + thumbUrl + '" class="yc-product-item-main-image" alt="' + data.product_type + ' > ' + data.title + '" />';
    // Build Image Swap
    if(bcSfFilterConfig.custom.active_image_swap){
        var flipImageUrl = images.length > 1 ? bcsffilter.optimizeImage(images[1]['src'], '150x150') : thumbUrl;
        html += '<img src="' + flipImageUrl + '" class="yc-product-item-flip-image" alt="' + data.product_type + ' > ' + data.title + '" />';
    }

    return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function isDiscountAvailable(product) {
  if(window.percentageDiscounts || window.amountDiscounts) {
      var products = Object.assign({}, window.percentageDiscounts, window.amountDiscounts);
      return Object.keys(products).some(function(discountProduct){
        if(product.indexOf(discountProduct)!==-1)
          return true;
        return false;
      });
  }
  return false;
}

function buildPrice(data) {
  var html = '';
  var discountedPrice;
  if (bcSfFilterConfig.custom.show_price) {
    if (onSale) {
        html += '<h3 class="yc-product-item-sale-price">' + slate.Currency.formatMoney(data.price_min) + '</h3>';
    } else {
      if (priceVaries) {
        html += (bcSfFilterConfig.label_basic.from) + ' ';
      }
        html += '<h3 class="bc-sf-filter-product-item-regular-price">' + slate.Currency.formatMoney(data.price_min) + '</h3>';
    }
    
    if(window.percentageDiscounts || window.amountDiscounts) {
      var products = Object.assign({}, window.percentageDiscounts, window.amountDiscounts);
      Object.keys(products).some(function(discountProduct){
        if(data.vendor === discountProduct) {
          var originalPrice = data.price_min;
          if(Object.keys(window.percentageDiscounts).indexOf(discountProduct)!==-1) {
            discountedPrice = originalPrice - (originalPrice/100 * products[discountProduct]);
            priceAfterDiscount = slate.Currency.formatMoney(discountedPrice);
          } else {
            discountedPrice = originalPrice -  (products[discountProduct]*100);
            priceAfterDiscount = slate.Currency.formatMoney(discountedPrice);
          }
          html +='<h3 class="discounted-price bc-discount hidden"> $' + priceAfterDiscount + '</h3>';
          return true;
        }
        return false;
      });

    }

    if(onSale) {
      html += '<span class="yc-product-item-msrp-price">ORIGINAL MSRP <span>' + slate.Currency.formatMoney(data.compare_at_price_min) + '</span></span> ';
    }
  }
  return {
    html,
    discountedPrice
  };
}
function buildCarrierStorage(data) {
  var html = '<span class="yc-product-item-variants">';
  if(data.carrier)
    html += '<span class="carrier '+slate.utils.handleize(data.carrier)+'"><label>Carrier</label><span></span></span>';
//   if(data.release)
//     html += '<span><label>Year</label><span>'+data.release+'</span></span>';
  if(data.processor)
    html += '<span><label>Processor</label><span>'+data.processor+'</span></span>';
  if(data.memory)
    html += '<span><label>Memory</label><span>'+data.memory+'</span></span>';
  if(data.capacity)
    html += '<span><label>Storage</label><span>'+data.capacity+'</span></span>';
//   if(data.screen)
//     html += '<span><label>Screen</label><span>'+data.screen+'</span></span>';
  if(data.condition)
    html += '<span><label>Condition</label><span>'+data.condition+'</span></span>';

    html += '</span>';
  return html;
}
function buildVariants(data, exclude, include) {
    var html = '';
    if (data.options_with_values.length > 0 && data.options[0] != "title") {
        html = '<span class="yc-product-item-variants">';
        data.options_with_values.forEach(function(variants){
            if((!exclude && !include) ||
              (exclude && variants.label != exclude) ||
              (include && variants.label == include)) {
              if (variants.values.length == 1) {
                  html += '<span><label>' + variants.label + '</label><span>' + variants.values[0].title + '</span></span>';
              }
              else {
                  var variantValues = [];
                  var optCode = '';
                  variants.values.forEach(function(values){
                    if(include) {
                      var selected = "";
                      optCode = 'opt_'+variants.label.toLowerCase().replace(' ', '_');
                      // jQ("#bc-sf-filter-tree .bc-sf-filter-option-block .bc-sf-filter-option-item").each(function() {
                      //   var id = jQ(this).data("id"),
                      //     title = jQ(this).data("title");
                      //     if(id == optCode && title == values.title && jQ(this).hasClass("selected"))
                      //       selected = ' class="active"'
                      // });
                      variantValues.push('<span'+selected+'>'+values.title+'</span>');
                    } else
                      variantValues.push(values.title);
                  });
                  var classes = "";
                  if(include) {
                    classes = ' class="'+optCode+'"';
                  }
                  html += '<span'+classes+'><label>' + variants.label + '</label><span>' + variantValues.join(", ") + '</span></span>';
              }
            }
        });
        html += '</span>';
    }
    return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    var color = 'color: ' + colorSoldOutLabel + ';';
    var border = ' border: 1px solid ' + borderColorSoldOutLabel + ';';
    var bg = ' background: ' + bgSoldOutLabel + ';';
    var style = 'style="' + color + border + bg + '";';
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, style);
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    var color = 'color: ' + colorSaleLabel + ';';
    var border = ' border: 1px solid ' + borderColorSaleLabel + ';';
    var bg = ' background: ' + bgSaleLabel + ';';
    var style = 'style="' + color + border + bg + '";';
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, style);
  }
  // Build Labels
  var html = soldOutLabel + saleLabel;
  return html
}

function buildAffirmText(data, discountedPrice) {
  var html ='';
  if(discountedPrice) {
    html = '<p class="affirm-as-low-as affirm-discounted-price hidden" data-amount='+discountedPrice+'></p>';
  }
  html += '<p class="affirm-as-low-as affirm-price" data-amount='+data.price_min+'></p>';
  return html;
}

/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

/************************** BUILD TOOLBAR **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  affirm.ui.refresh();
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.bottomPagination).html('');
    return false;
  }

  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);

    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }

    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

    jQ(this.selector.bottomPagination).html(paginationHtml);
  }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');

    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  // Call function to get extra product html by ajax
  this.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
    results.forEach(function(result){
      var currentItemStatus = jQ('[boost-item="'+ result.id+ '"]').data('status');
      var upgradeItemStatus = parseInt(result.custom_html);
      var currentItemLink = jQ('[boost-item="'+ result.id+ '"]').find('.yc-product-item-link').attr('href');
      if(currentItemStatus <= 0 && upgradeItemStatus > 0){
        var viewHtml = '<a class="btn btn-primary btn-sm view-cta" href="'+ currentItemLink +'">View</a>';
        jQ('[boost-item="'+ result.id+ '"]').removeClass('sold-out');
        jQ('[boost-item="'+ result.id+ '"]').find('.view-cta').replaceWith(viewHtml);
      }
    })
  })
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  /* Start Initialize BC QuickView */
  if (typeof(bcQuickView) !== 'undefined') {
    if (typeof(bcQuickViewParams) !== 'undefined') {
      bcQuickView.init(bcQuickViewParams);
    } else {
      bcQuickView.init();
    }
  }
  /* End Initialize BC QuickView */

  matchHeightImage();
  jQ(window).resize(function() {
    matchHeightImage();
  })

  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) buildImageSwap();
};

function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).parent();
    imageContainer.css('width', '100%').css('height', $(this).height());
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
  // jQ('.bc-sf-filter-product-item').each(function(){
  //     var mainImage = jQ(this).find('.bc-sf-filter-product-item-main-image');
  //     var imageContainer = jQ(this).find('.bc-sf-filter-product-item-image');
  //     mainImage.one('load', function() {
  //         imageContainer.css('width', '100%').css('height', mainImage.height());
  //     }).each(function() {
  //         if(this.complete) jQ(this).load();
  //     });
  // });
}

// Build Image Swap
function buildImageSwap() {
  jQ('.bc-sf-filter-product-item-image').each(function() {
    jQ(this).children('img').css({
      'position': 'absolute',
      'top': 0,
      'left': 0,
      'width': '100%'
    })
  });
  jQ('.bc-sf-filter-product-item-main-image').hover(function() {
    jQ(this).css('opacity', 0);
    jQ(this).siblings().show();
  }, function() {
    jQ(this).css('opacity', 1);
    jQ(this).siblings().hide();
  });
}

// Build Breadcrumb
// BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
//     if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
//         var breadcrumbHtml = bcSfFilterTemplate.breadcrumbHtml;
//         var colInfo = colData.collection;
//         // Build Tags
//         var currentTagsHtml = '';
//         if (Array.isArray(bcSfFilterConfig.general.current_tags)) {
//             var current_tags = bcSfFilterConfig.general.current_tags;
//             for (var k in current_tags) {
//                 var tag = current_tags[k];
//                 currentTagsHtml += '&nbsp; / &nbsp;';
//                 currentTagsHtml += '<span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/{{currentCollectionLink}}/' + this.slugify(tag) + '" title="' + tag + '" itemprop="item"><span itemprop="name">' + tag + '</span></a></span>';
//             }
//         }
//         // Build Collection Info
//         breadcrumbHtml = breadcrumbHtml.replace(/{{currentTags}}/g, currentTagsHtml);
//         breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
//         // Top Pagination
//         var currentPage = parseInt(this.queryParams.page);
//         var totalPage = Math.ceil(apiData.total_product / this.queryParams.limit);
//         var topPaginationHtml = '&nbsp; / &nbsp;' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage)
//         breadcrumbHtml = breadcrumbHtml.replace(/{{topPagination}}/g, topPaginationHtml);

//         jQ(this.selector.breadcrumb).html(breadcrumbHtml);
//     }
// };

function buildDefaultLink(a, b) {
  var c = window.location.href.split("?")[0];
  return c += "?" + a + "=" + b
}
BCSfFilter.prototype.buildDefaultElements = function(a) {
  if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) {
    var b = bcSfFilterConfig.general.collection_count,
      c = parseInt(this.queryParams.page),
      d = Math.ceil(b / this.queryParams.limit);
    if (1 == d) return jQ(this.selector.pagination).html(""), !1;
    if ("default" == this.getSettingValue("general.paginationType")) {
      var e = bcSfFilterTemplate.paginateHtml,
        f = "";
      f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)), e = e.replace(/{{previous}}/g, f);
      var g = "";
      g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)), e = e.replace(/{{next}}/g, g);
      for (var h = [], i = c - 1; i > c - 3 && i > 0; i--) h.unshift(i);
      c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c);
      for (var j = [], k = c + 1; k < c + 3 && k <= d; k++) j.push(k);
      c + 3 < d && j.push("..."), c + 3 <= d && j.push(d);
      for (var l = "", m = h.concat(j), n = 0; n < m.length; n++) "..." == m[n] ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, l = l.replace(/{{itemTitle}}/g, m[n]), l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n]));
      e = e.replace(/{{pageItems}}/g, l), jQ(this.selector.pagination).html(e)
    }
  }
  if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && jQ(this.selector.topSorting).length > 0) {
    jQ(this.selector.topSorting).html("");
    var o = this.getSortingList();
    if (o) {
      var p = "";
      for (var q in o) p += '<option value="' + q + '">' + o[q] + "</option>";
      var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p);
      jQ(this.selector.topSorting).html(r);
      var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting;
      jQ(this.selector.topSorting + " select").val(s), jQ(this.selector.topSorting + " select").change(function(a) {
        window.location.href = buildDefaultLink("sort_by", jQ(this).val())
      })
    }
  }
};

var monkeyChange = BCSfFilter.prototype.onChangeData;
BCSfFilter.prototype.onChangeData = function(a, b, c, d, e) {
  document.dispatchEvent(new CustomEvent("filterChanged", {model: this, detail: {code: b, value: c}}))
  if(monkeyChange)
    monkeyChange.call(this, a, b, c, d, e);

  var currentUrl = window.location.href;
  localStorage.setItem("BCSfFilteredUrl", currentUrl);
}

var monkeyBuildUrl = BCSfFilter.prototype.buildProductItemUrl;
BCSfFilter.prototype.buildProductItemUrl = function(product, b) {
  var url = monkeyBuildUrl.call(this, product, b);
  var qs = slate.utils.getQueryString();
  var selectedColor = qs['pf_opt_color'];
  var selectedCondition = qs['pf_opt_cosmetic_condition'];
  if(selectedColor && selectedCondition) {
    var compareColor = 'color:'+selectedColor;
    var compareCondition = 'cosmetic_condition:'+selectedCondition;
    var variant = $.grep(product.variants, function(v) {
      return (v.merged_options[0] == compareColor || v.merged_options[0] == compareCondition) &&
        (v.merged_options[1] == compareColor || v.merged_options[1] == compareCondition)
    })[0];
    if(variant) {
      url += '?variant='+variant.id;
    }
  }
  return url;
}


BCSfFilter.prototype.buildFilterOptionBox = function(a, b) {
  a.hasOwnProperty("values") && ("all" == a.valueType || this.getSettingValue("general.sortManualValues") || "all" != a.valueType && a.sortManualValues) && (a.values = this.sortFilterOptionValue(a));
  var c = ""
    , d = a.filterType
    , e = a.displayType
    , f = a.selectType
    , g = a.filterOptionId
    , h = a.label;
  if (a.label.toLowerCase() === "cosmetic condition") {
    var specificOrder = ["Premium", "Excellent", "Good", "Fair"]
    for (var so in specificOrder) {
      for (var i in a.values) {
        if (a.values[i].key === specificOrder[so]) {
          c += this.buildFilterOptionBoxData(d, g, h, e, f, a.values[i], a);
        }
      }
    }
  }
  else {
    for (var i in a.values)
      c += this.buildFilterOptionBoxData(d, g, h, e, f, a.values[i], a);
  }

  if ("" != c) {
      var j = this.getTemplate("filterOptionBox");
      j = j.replace(/{{itemList}}/g, c),
      this.buildFilterOption(j, a, b)
  }
}

// Prepare Search params
BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
    if (this.isSearchPage()) {
        params['q'] = this.getSearchTerm();
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
        if (this.getSettingValue('search.reduceMinMatch')) params.reduce_min_match = true;
    }
  params.sort_first = 'available';
    return params;
};

// Add additional feature for product list, by calling ajax
BCSfFilter.prototype.buildExtrasProductListByAjax = function(data, templateName, callback, numberProductPerAjaxCall, jsonResult, ajaxPage){
    var self = this;
    if (!ajaxPage) ajaxPage = 0;
	// We can only get 20 products per ajax call, if there are more than 20 products per page, we need to call multiple times
	if (!numberProductPerAjaxCall || numberProductPerAjaxCall > 20){
		numberProductPerAjaxCall = 20;
	}
    var fromIndex = numberProductPerAjaxCall * ajaxPage;
	var toIndex = Math.min(data.length, numberProductPerAjaxCall * (ajaxPage + 1));
	var handles = [];
	for (var i = fromIndex; i < toIndex; i++) {
		handles.push(data[i].handle);
	}
	var handleString = handles.join("+");
    if (!jsonResult) jsonResult = [];
    var itemDataUrl;
    itemDataUrl = "/collections/all/" + handleString + "?view=" + templateName;
	jQ.ajax({
		type: "GET",
		url: itemDataUrl,
		success: function (ajaxResult) {
			// Try to parse the json we get from collection endpot
			try {
                if(typeof Shopify.PaymentButton === "undefined" && /<\!--.*?-->/.test(ajaxResult)){
                    ajaxResult = ajaxResult.replace(/<\!--.*?-->/g, "");
                }
				jsonResult = jsonResult.concat(JSON.parse(ajaxResult).products);
			} catch (error) {
				console.log('Could not parse json from ' + itemDataUrl + ": " + error.message);
				return;
			}
			// We can only get 20 products per ajax call, if there are more than 20 products per page, we need to call multiple times
    		if (fromIndex < data.length - 1){
    		    ajaxPage++;
    		    self.buildExtrasProductListByAjax(data, templateName, callback, numberProductPerAjaxCall, jsonResult, ajaxPage);
    		} else if (typeof callback == 'function') {
    		    callback(jsonResult);
    		}
		}
	});
};

// Anaylyze result from API and Build elements
BCSfFilter.prototype.afterGetFilterData = function(result, eventType) {
    var self = this;
  
    if (!this.pageOverFallback(result)) {
        // Restore the active currency prices
        if (typeof this.activeCurrencyPrices !== 'undefined') {
            jQ.extend(self.queryParams, this.activeCurrencyPrices);
        }
        // Hide Loading
        this.hideLoading();
        // Remove Placeholder for Filter tree
        if (typeof this.removePlaceholderForFilterTree !== 'undefined') {
            this.removePlaceholderForFilterTree();
        }
        // Hide Loading of Infinite or Load More
        if (['infinite', 'load_more'].indexOf(this.getSettingValue('general.paginationType')) > -1 && this.getSettingValue('general.showLoadMoreLoading') && this.getSettingValue('general.showLoading') === false) {
            this.hideLoadMoreLoading();
        }
        // Re-display Load More button
        // if (this.getSettingValue('general.paginationType') == 'load_more') {
        //     if (result.products.length < this.queryParams.limit) {
        //         jQ(this.getSelector('loadMore')).hide();
        //     } else {
        //         jQ(this.getSelector('loadMore')).show();
        //         jQ(this.getSelector('loadMoreButtonContainer')).show();
        //     }
        // }

        // Reset Collapsed list after filtering by Collection
        if (eventType == 'collection') {
            var openListClass = bcsffilter.class.filterOptionOpenList, closeListClass = bcsffilter.class.filterOptionCloseList;
            if (jQ('.' + openListClass).length > 0) jQ('.' + openListClass).remove();
            if (jQ('.' + closeListClass).length > 0) jQ('.' + closeListClass).remove();
        }

        // Check has error from API result
        if (result.hasOwnProperty('errorMessage')) {
            // this.showError('Oops, we cannot fetch products at this moment. Please try again later.');
        } else {
            // If result returns empty product, print error and does not display product column
            this.catchError(result, eventType);
            // Build elements
            this.buildAll(result, this.queryParams.build_filter_tree, eventType);
        }
    }
};

// Fix page param is over then the totalPage
BCSfFilter.prototype.pageOverFallback = function(data) {
    // Check page fallback if the total_product > 0 but the product is empty
    if (data.total_product > 0 && Array.isArray(data.products) && data.products.length == 0) {
        var limit = this.queryParams.limit || false,
            curentPage = this.queryParams.page || 1,
            totalPage = Math.ceil(data.total_product / limit);
        if (limit && curentPage > 1 && curentPage > totalPage) {
            this.queryParams.page = totalPage;
            var urlW = new URL(window.location.href);
            if (urlW.searchParams.get('page') !== null) urlW.searchParams.delete("page");
            urlW.searchParams.append('page', totalPage);

            if (typeof History !== 'undefined') {
                History.replaceState('', '', urlW.toString().replace(/\+/g, '%20'));
                return true;
            }
        }
    }
    return false;
}
// -- Start Filter Utils -- //
